// extracted by mini-css-extract-plugin
module.exports = {"selo":"DecorarBadge_selo__gX40W","label":"DecorarBadge_label__m8EXm"};